export const parseIntComma = string => {
  return parseInt(string.replace(/,/g, ''));
};

export const parseFloatComma = string => {
  return parseFloat(string.replace(/,/g, ''));
};
